import { LOGIN } from "../routing/routes.constant";

const tokenKey = "mtTok";
const pdidevice = "pdidevice";
const initialize = "initialize";
const deviceId = "x-device-id";

export const token = () => {
  return localStorage.getItem(tokenKey);
};
export const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
};
export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};

export const authentication = () => {
  if (token()) {
    return true;
  } else {
    return false;
  }
};

export function loginSuccessfully(response, navigate, redirect) {
  //Set Token
  setToken(response?.authToken);
  //Check if user login first time
  navigate(redirect || "/");
  //Reload
  window.location.reload();
}

export function logoutSuccessfully(navigate) {
  removeToken();
  if (navigate) {
    navigate(LOGIN.fullUrl);
  } else {
    window.location.href = LOGIN.fullUrl;
  }
}

export function setPlatformData(data) {
  sessionStorage.setItem(pdidevice, JSON.stringify(data));
}

export function getPlatformData() {
  const pData = sessionStorage.getItem(pdidevice);
  return pData ? JSON.parse(pData) : null;
}

export function setAppInitialize() {
  sessionStorage.setItem(initialize, JSON.stringify({ initialize: true }));
}

export function generateDeviceId() {
  try {
    const { uuid } = window?.device || {};
    if (uuid) {
      return uuid;
    } else {
      return `pdi${Date.now().toString(36)}${Math.random()
        .toString(36)
        .substring(2, 10)}`;
    }
  } catch (error) {
    return "UnknownId";
  }
}

export function setDeviceId() {
  const getDeviceId = getCookie(deviceId);
  if (!getDeviceId) {
    const newId = generateDeviceId();
    setCookie(deviceId, newId, 390, "/", false);
  }
}

export function getCookie(name) {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      const value = c.substring(nameEQ.length);
      try {
        return decodeURIComponent(value);
      } catch (e) {
        return value;
      }
    }
  }
  return null;
}

export function setCookie(name, value, days = 7, path = "/", secure = true) {
  let expires = "";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = `${name}=${encodeURIComponent(
    value
  )}${expires}; path=${path}; domain=.pahadirishta.com${
    secure ? "; Secure; SameSite=None" : ""
  }`;
}

export function getAppInitialize() {
  const initializeData = sessionStorage.getItem(initialize);
  return initializeData ? JSON.parse(initializeData) : null;
}

export function setLocalStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}
export function getLocalStorage(key) {
  return localStorage.getItem(key);
}
